import { isDevMode } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export function getErrorMessages(control?: AbstractControl): string | undefined {
    if (!control || (!control.dirty && !control.touched) || !control.errors) return;

    if (control.getError('required')) {
        if (control.getError('required').message) {
            return control.getError('required').message;
        }
        return 'Required field';
    }

    const maxError = control.getError('max');
    if (maxError) return 'Maximum value is ' + maxError.max + '. Actual value is ' + maxError.actual;

    const maxError2 = control.getError('maxError');
    if (maxError2)
        return (
            'Maximum value is ' +
            new Date(maxError2.maxErrorValue).toLocaleString() +
            '. Actual value is ' +
            new Date(maxError2.value).toLocaleString()
        );

    const minError = control.getError('min');
    if (minError) return 'Minimum value is ' + minError.min + '. Actual value is ' + minError.actual;

    const minError2 = control.getError('minError');
    if (minError2)
        return (
            'Minimum value is ' + new Date(minError2.minValue).toLocaleString() + '. Actual value is ' + new Date(minError2.value).toLocaleString()
        );

    const minLengthError = control.getError('minlength');
    if (minLengthError) return 'Minimum length is ' + minLengthError.requiredLength + ' characters. Actual length is ' + minLengthError.actualLength;

    const maxLengthError = control.getError('maxlength');
    if (maxLengthError) return 'Maximum length is ' + maxLengthError.requiredLength + ' characters. Actual length is ' + maxLengthError.actualLength;

    if (control.getError('pattern')) return 'Invalid format';

    if (control.getError('email')) return 'Invalid email format';

    if (control.getError('patternError')) {
        const mask = control.getError('patternError').mask;
        if (mask) {
            return `Value does not match the required format: ${mask}`;
        }
        return 'Invalid format';
    }

    return control.errors ? (isDevMode() ? JSON.stringify(control.errors) : 'Invalid value') : undefined;
}

export class FormGroupRegexValidators {
    static zipUS = '^[0-9]{5}(?:-[0-9]{4})?$';
    static zipAU = '^[0-9]{4}$';
}

export function getErrors(formGroup: AbstractControl): string[] {
    const errors: string[] = [];

    if (formGroup instanceof FormGroup) {
        Object.keys(formGroup.controls).forEach((key) => {
            const control = formGroup.get(key);
            if (control) {
                const errorMessage = getErrors(control);
                if (errorMessage) {
                    errorMessage.forEach((msg) => errors.push(`${key}: ${msg}`));
                }
            }
        });
    } else if (formGroup instanceof FormArray) {
        formGroup.controls.forEach((control, index) => {
            const errorMessage = getErrors(control);
            if (errorMessage) {
                errorMessage.forEach((msg) => errors.push(`Index ${index}: ${msg}`));
            }
        });
    } else {
        const errorMessage = formGroup.errors;
        if (errorMessage) {
            errors.push(`${errorMessage}`);
        }
    }

    return errors;
}
